"use strict";
var $dyn;
(function ($dyn) {
    var _npsHandler;
    (function (_npsHandler) {
        _npsHandler._npsUrlOrigin = "";
        _npsHandler._npsUserGuid = "";
        _npsHandler._npsPlatformVersionParameter = "";
        _npsHandler._npsApplicationVersionParameter = "";
        function init() {
            var isPreProd = false;
            if (!$dyn.flags.disableNPS && $dyn.user() && $dyn.user().UserGuid && $dyn.user().UserGuid()) {
                isPreProd = $dyn.skypeInteraction.isPreProdUser();
                _npsHandler._npsUrlOrigin = isPreProd ? "https://nps-int.onyx.azure.net" : "https://nps.onyx.azure.net";
                _npsHandler._npsUserGuid = $dyn.user().UserGuid();
                if ($dyn.shell.ProductId === "dyntalent" || $dyn.shell.ProductId === "dynrcs") {
                    _npsHandler._npsUserGuid = _npsHandler._npsUserGuid.toLowerCase();
                }
                _npsHandler._npsPlatformVersionParameter = "&productVersion=" + $dyn.user().PlatformVersion();
                _npsHandler._npsApplicationVersionParameter = "&custom=" + encodeURIComponent(JSON.stringify({ applicationVersion: $dyn.user().AppVersion() }));
                // check if string starts and ends with {} if so strip them off for Guid value
                if (_npsHandler._npsUserGuid.charAt(0) === "{" && _npsHandler._npsUserGuid.charAt(_npsHandler._npsUserGuid.length - 1) === "}") {
                    _npsHandler._npsUserGuid = _npsHandler._npsUserGuid.substr(1);
                    _npsHandler._npsUserGuid = _npsHandler._npsUserGuid.substr(0, _npsHandler._npsUserGuid.length - 1);
                }
                if (!$dyn.restrictedNavigation) {
                    // wait 300 sec before any render if needed
                    window.setTimeout(function () {
                        if ($dyn.util.location.query.forceNPS) {
                            // force the NPS dialog
                            DisplayDialog(true);
                        }
                        else if (!isPreProd) {
                            // make call to see if we need to display the NPS dialog
                            CheckDisplayValid();
                        }
                    }, 300000);
                }
            }
        }
        _npsHandler.init = init;
        /**
         * makes call to retrieve if dialog should be displayed
         * @internal
         */
        function CheckDisplayValid() {
            var url = _npsHandler._npsUrlOrigin + "/display/" + $dyn.shell.ProductId + "?culture=" + Globalize.culture().name + "&puid=" + _npsHandler._npsUserGuid + _npsHandler._npsPlatformVersionParameter;
            $.ajax({
                beforeSend: function () {
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("nps");
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax();
                },
                cache: false,
                type: "GET",
                url: url,
            }).done(function (data) {
                DisplayDialog(data.display);
            }).fail(function (request, textStatus, error) {
                $dyn.logWarning(error);
            }).always(function () {
                $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
            });
        }
        _npsHandler.CheckDisplayValid = CheckDisplayValid;
        /**
         * if dialog should be displayed, will make call to get the iframe elements to display
         * @internal
         * @param shouldDisplay
         */
        function DisplayDialog(shouldDisplay) {
            // should we display it?
            if (shouldDisplay === true) {
                var url_1 = _npsHandler._npsUrlOrigin + "/render/" + $dyn.shell.ProductId + "?culture=" + Globalize.culture().name + "&puid=" + _npsHandler._npsUserGuid + _npsHandler._npsPlatformVersionParameter + _npsHandler._npsApplicationVersionParameter;
                var container = document.getElementById("npsServiceModal");
                // Create an iframe with the src applied to avoid mangling the
                // browser history.
                var frame = document.createElement("iframe");
                frame.id = "npsServiceModaliFrame";
                frame.src = url_1;
                frame.className = "npsServiceModaliFrame";
                window.addEventListener("message", $dyn._npsHandler.ModalMessageHandler, false);
                container.appendChild(frame);
                container.style.display = "block";
            }
        }
        _npsHandler.DisplayDialog = DisplayDialog;
        /**
         * handles any iframe message coming from the nps rendering service.
         * @internal
         * @param event
         */
        function ModalMessageHandler(event) {
            var data = event.data || {};
            if (!event || !event.origin) {
                return;
            }
            if ($dyn._npsHandler._npsUrlOrigin.indexOf(event.origin) < 0) {
                return;
            }
            switch (data.msgType) {
                case "closeNpsDialog":
                    window.removeEventListener("message", $dyn._npsHandler.ModalMessageHandler, false);
                    var modal = document.getElementById("npsServiceModal");
                    var closeFrame = document.getElementById("npsServiceModaliFrame");
                    if (modal) {
                        if (closeFrame) {
                            modal.removeChild(closeFrame);
                        }
                        modal.style.display = "none";
                    }
                    break;
                case "thankyouNpsDialog":
                    var thankFrame = document.getElementById("npsServiceModaliFrame");
                    if (thankFrame) {
                        thankFrame.classList.add("npsThankYou");
                    }
                    break;
                default:
                    // Don't do anything.
                    break;
            }
        }
        _npsHandler.ModalMessageHandler = ModalMessageHandler;
    })(_npsHandler = $dyn._npsHandler || ($dyn._npsHandler = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=nps-handler.js.map
